import Encode from './Encode';

export default Encode;
